// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2bovQ","requiredAsterisk":"Info_requiredAsterisk__1hJys"};